<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Drop Downs" pageTitle="Drop Downs" />
            <DropDowns />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DropDowns from '../DropDowns/DropDowns'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DropDownsPage',
    components: {
        MainHeader,
        PageTitle,
        DropDowns,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>